import React, { useMemo, useState } from 'react';
import { Button } from 'antd';

const StepReviewAndPublish = ({ onBack, formData }) => {
  const [viewMode, setViewMode] = useState('summary');

  const summaryRows = useMemo(() => [
    {
      heading: '1 - Basic Info',
      rows: [
        { label: 'Rule Name', value: formData.ruleName || '—' },
        { label: 'Storefront', value: formData.storefront || '—' },
        { label: 'Rule Description', value: formData.ruleDescription || '—' },
      ],
    },
    {
      heading: '2 - Rule Details',
      rows: [
        { label: 'Rule Type', value: formData.ruleType || '—' },
        { label: 'Member Type', value: formData.memberType || '—' },
        { label: 'Active Period', value: `${formData.activeStartDate || '—'} → ${formData.activeEndDate || 'No end date'}` },
        { label: 'Attribute Conditions', value: formData.attributeCondition || '—' },
        { label: 'Redemption Limit', value: formData.redemptionLimit || '—' },
        { label: 'Priority', value: formData.priority || '—' },
      ],
    },
    {
      heading: '3 - Benefit & Mechanic',
      rows: [
        { label: 'Min Cart Value', value: formData.minCartValue || '—' },
        { label: 'Gift Enabled', value: formData.giftEnabled ? 'Yes' : 'No' },
        { label: 'Gift SKUs', value: Array.isArray(formData.giftSkus) ? formData.giftSkus.join(', ') || '—' : formData.giftSkus || '—' },
        { label: 'Gifts Per Order', value: formData.giftsPerOrder || '—' },
        { label: 'Discount Enabled', value: formData.discountEnabled ? 'Yes' : 'No' },
        { label: 'Discount Type', value: formData.discountType || '—' },
        { label: 'Discount Value', value: formData.discountValue || '—' },
      ],
    },
    {
      heading: '4 - Products (Include / Exclude)',
      rows: [
        { label: 'List Type', value: formData.listType || '—' },
        { label: 'SKU Source', value: formData.skuSource || '—' },
        { label: 'Included SKUs', value: formData.includedSkus || '—' },
      ],
    },
  ], []);

  return (
    <div style={{ padding: '24px 0 0 0' }}>
      <div style={{ maxWidth: 980, margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>         
          <div style={{ fontSize: 16, fontWeight: 700, color: '#1f2937' }}>Review & Publish</div>
        </div>

        <div style={{ borderTop: '1px solid #e5e7eb', paddingTop: 18 }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 700 }}>{viewMode === 'summary' ? 'Summary' : 'JSON View'}</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
              <button
                type="button"
                onClick={() => setViewMode('summary')}
                style={{ border: 'none', background: 'transparent', color: viewMode === 'summary' ? '#1f6feb' : '#4b5563', fontWeight: 600, cursor: 'pointer' }}
              >
                Summary
              </button>
              <button
                type="button"
                onClick={() => setViewMode('json')}
                style={{ border: 'none', background: 'transparent', color: viewMode === 'json' ? '#1f6feb' : '#4b5563', fontWeight: 600, cursor: 'pointer' }}
              >
                JSON View
              </button>
            </div>
          </div>

          {viewMode === 'summary' ? (
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, overflow: 'hidden' }}>
              {summaryRows.map((section, index) => (
                <div key={section.heading}>
                  <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', borderBottom: '1px solid #e5e7eb', padding: '14px 16px', background: '#f3f4f6' }}>
                    <div style={{ fontWeight: 700 }}>{section.heading}</div>
                    <div style={{ textAlign: 'right', color: '#1f6feb', cursor: 'pointer' }}>Edit</div>
                  </div>
                  {section.rows.map((row) => (
                    <div key={row.label} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', padding: '14px 16px', borderBottom: '1px solid #e5e7eb' }}>
                      <div>{row.label}</div>
                      <div style={{ textAlign: 'right', whiteSpace: 'pre-wrap' }}>{row.value}</div>
                    </div>
                  ))}
                  {index !== summaryRows.length - 1 && <div style={{ height: 8, background: '#ffffff' }} />}
                </div>
              ))}
            </div>
          ) : (
            <div style={{ border: '1px solid #e5e7eb', borderRadius: 10, background: '#111827', color: '#e5e7eb', padding: 16, overflowX: 'auto' }}>
              <pre style={{ margin: 0, fontSize: 12, lineHeight: 1.6, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {JSON.stringify(formData, null, 2)}
              </pre>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 32 }}>
          <Button onClick={onBack} style={{ minWidth: 160, height: 42, borderRadius: 8, fontWeight: 600 }}>← Previous: Products (Include/Exclude)</Button>
          <Button type="primary" style={{ minWidth: 160, height: 42, borderRadius: 8, fontWeight: 600 }}>Publish Rule</Button>
        </div>
      </div>
    </div>
  );
};

export default StepReviewAndPublish;
